<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <b-media class="text-center ml-5 mr-5">
            </b-media>
        </base-header>
        <b-container class="container-fluid mt--7">
            <div>
                <h1>Speech color changer</h1>

                <p class="hints"></p>
                <div>
                    <p class="output"><em>...diagnostic messages</em></p>
                </div>
            </div>
        </b-container>
    </div>
</template>

<script>
    export default {
        name: "SpeechTestVue",
        mounted() {
            //
        }
    }
</script>

<style scoped>

</style>